import { render, staticRenderFns } from "./classify14.vue?vue&type=template&id=4d01d8f7"
import script from "./classify14.vue?vue&type=script&lang=js"
export * from "./classify14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports